class ChannelService {
  // constructor() {
  //   this.loadScript();
  // }

  isEnabled() {
    return process.env.VUE_APP_ENABLE_CHANNEL_IO === "true" && !!process.env.VUE_APP_CHANNEL_SERVICE_PLUGIN_ID;
  }

  hasChannelIO() {
    return this.isEnabled() && typeof window !== "undefined" && typeof window.ChannelIO === "function";
  }

  loadScript() {
    if (!this.isEnabled()) return;

    (function()
      {
        var w=window;
        if(w.ChannelIO){
          // return w.console.error("ChannelIO script included twice.")
          return w.console.log('ChannelIO already included.')
        }
        var ch=function(){ch.c(arguments)};
        ch.q=[];
        ch.c=function(args){ch.q.push(args)};
        w.ChannelIO=ch;
        function l(){if(w.ChannelIOInitialized){return}w.ChannelIOInitialized=true;
        var s=document.createElement("script");
        s.type="text/javascript";
        s.async=true;
        s.src="https://cdn.channel.io/plugin/ch-plugin-web.js";
        var x=document.getElementsByTagName("script")[0];
        if(x.parentNode){x.parentNode.insertBefore(s,x)}}
        if(document.readyState==="complete"){l()}
        else{w.addEventListener("DOMContentLoaded",l);
        w.addEventListener("load",l)}
      }
    )();
  }

  boot(option, callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('boot', option, callback);
  }

  shutdown() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('shutdown');
  }

  showMessenger() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('showMessenger');
  }
  
  hideMessenger() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('hideMessenger');
  }

  openChat(chatId, message) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('openChat', chatId, message);
  }

  track(eventName, eventProperty) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('track', eventName, eventProperty);
  }
  
  onShowMessenger(callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('onShowMessenger', callback);
  }
  
  onHideMessenger(callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('onHideMessenger', callback);
  }
  
  onBadgeChanged(callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('onBadgeChanged', callback);
  }

  onChatCreated(callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('onChatCreated', callback);
  }

  onFollowUpChanged(callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('onFollowUpChanged', callback);
  }

  onUrlClicked(callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('onUrlClicked', callback);
  }

  clearCallbacks() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('clearCallbacks');
  }
  
  updateUser(userInfo, callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('updateUser', userInfo, callback);
  }

  addTags(tags, callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('addTags', tags, callback);
  }

  removeTags(tags, callback) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('removeTags', tags, callback);
  }

  setPage(page) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('setPage', page);
  }

  resetPage() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('resetPage');
  }

  showChannelButton() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('showChannelButton');
  }

  hideChannelButton() {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('hideChannelButton');
  }

  setAppearance(appearance) {
    if (!this.hasChannelIO()) return;
    window.ChannelIO('setAppearance', appearance);
  }
}

export default new ChannelService();
